import _ from 'lodash'
import moment from 'moment'
import styled from 'styled-components'
import { useEffect, useState } from 'react'

import api from '../services/api'
import useModal from '../hooks/useModal'

import BasicPagination from '../components/Paginations'
import { ReactComponent as DailyLogIcon } from '../assets/images/menu/daily_log_icon.svg'
import { BasicBtn } from '../components/Buttons'

export default function DailyLog() {
  const limit = 7
  const { openModal, closeModal } = useModal()
  const [dailyLogList, setDailyLogList] = useState()
  const [currentPage, setCurrentPage] = useState(1)

  useEffect(() => {
    api.get('/daily-logs', { params: { page: 1, limit } })
      .then(result => setDailyLogList(result.data))
      .catch(e => {
        console.error(e)
        openModal({
          type: 'alert',
          props: {
            isError: true,
            contents: e.response?.data.message || e.message,
          },
        })
      })
  }, [])

  function handlePageChange(event, v) {
    setCurrentPage(v)
    api.get('/daily-logs', { params: { page: v, limit } })
      .then(result => setDailyLogList(result.data))
      .catch(e => {
        console.error(e)
        openModal({
          type: 'alert',
          props: {
            isError: true,
            contents: e.response?.data.message || e.message,
          },
        })
      })
  }

  return (
    <PageWrapper>
      <Header>
        <TitleWrapper>
          <DailyLogIcon className="title-icon" width="2em" fill="#333" />
          <div>
            <h1>데일리 로그</h1>
            <p>매 분, 매시간 내가 무엇을 하는지, 얼마나 집중하는지 기록해 보세요</p>
          </div>
        </TitleWrapper>
        <BasicBtn
          height="40px"
          width="160px"
          onClick={() =>{
            openModal({
              type: 'getDailyLog',
              props: { logOn: moment().format('YYYY-MM-DD'), setDailyLogList, currentPage, limit },
            })
          }
        }
        >
          데일리 로그 추가
        </BasicBtn>
      </Header>

      <ContentWrapper>
        <p>
          <span className="total-count">
            {parseInt(dailyLogList?.pagination?.totalNum).toLocaleString('ko-KR')}
          </span>
          개의 데일리 로그가 있어요
        </p>

        <LogList>
          {_.map(dailyLogList?.dailyLogList, (dl) => (
            <LogItem
              key={dl.logOn}
              onClick={() => {
                openModal({
                  type: 'getDailyLog',
                  props: { logOn: dl.logOn, setDailyLogList, currentPage, limit },
                })
              }
            }
            >
              <DailyLogIcon className="title-icon" width="1.5em" fill="#777" />
              <p>
                <span className="log-date">{dl.logOn}</span> &emsp;데일리 로그
              </p>
            </LogItem>
          ))}
        </LogList>
      </ContentWrapper>

      <PaginationWrapper>
        <BasicPagination totalPage={dailyLogList?.pagination.totalPage} onChange={handlePageChange} />
      </PaginationWrapper>
    </PageWrapper>
  )
}

const PageWrapper = styled.div`
  margin: 30px;
  position: relative;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 30px;
`

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  h1 {
    font-size: 2rem;
    font-weight: bold;
    color: #333;
    margin: 0;
  }
  p {
    font-size: 1rem;
    color: #777;
    margin-top: 8px;
  }
`

const ContentWrapper = styled.div`
  width: 100%;
  max-width: 900px;
  padding: 0 20px;
  text-align: center;

  .total-count {
    font-weight: bold;
    color: ${props => props.theme.colors.muiPrimary};
    font-size: 1.2em;
  }
`

const LogList = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`

const LogItem = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 14px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #fff;
  transition: all 0.3s ease;
  width: 100%;
  max-width: 700px;
  margin: 0 auto;

  &:hover {
    background-color: #f7f7f7;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  }

  .title-icon {
    margin-right: 12px;
  }

  p {
    font-size: 1.2em;
    color: #333;
  }

  .log-date {
    font-weight: bold;
    color: ${props => props.theme.colors.muiPrimary};
  }
`

const PaginationWrapper = styled.div`
  margin-top: 30px;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 20px 0;
`
